export default "__VITE_ASSET__NBXgfgT9__"